var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEditNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "#64798F",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.563 5.626 L 2.573 6.248 7.464 6.256 L 12.355 6.265 12.355 5.635 L 12.355 5.005 7.454 5.005 L 2.553 5.005 2.563 5.626 M2.563 9.056 L 2.573 9.678 7.464 9.686 L 12.355 9.695 12.355 9.065 L 12.355 8.435 7.454 8.435 L 2.553 8.435 2.563 9.056 M16.275 9.973 C 16.092 10.009,16.042 10.046,15.689 10.402 L 15.365 10.728 16.100 11.462 L 16.835 12.196 17.170 11.864 C 17.354 11.682,17.527 11.490,17.555 11.438 C 17.626 11.303,17.618 11.013,17.539 10.857 C 17.450 10.683,16.763 10.018,16.646 9.994 C 16.454 9.954,16.394 9.951,16.275 9.973 M12.276 13.816 L 10.080 16.013 10.080 16.756 L 10.080 17.500 10.806 17.500 L 11.533 17.500 13.738 15.295 L 15.942 13.090 15.207 12.355 L 14.472 11.620 12.276 13.816 M2.563 12.486 L 2.573 13.108 5.696 13.116 L 8.820 13.125 8.820 12.495 L 8.820 11.865 5.687 11.865 L 2.553 11.865 2.563 12.486 ",
    stroke: "none",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditNote);
export default __webpack_public_path__ + "static/media/icon-edit-note.97015400ad7c1c3b29874a8ddb807f6a.svg";
export { ForwardRef as ReactComponent };